import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import { store } from '@/store'

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/roles',
      name: 'roles',
      component: () => import('./views/Roles'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('./views/Users'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/users/:id',
      name: 'user',
      component: () => import('./views/User'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/teams',
      name: 'teams',
      component: () => import('./views/Teams'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/teams/:id',
      name: 'team-info',
      component: () => import('./views/Team'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/plans',
      name: 'plans',
      component: () => import('./views/Plans'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/addons',
      name: 'addons',
      component: () => import('./views/Addons'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/discounts',
      name: 'discounts',
      component: () => import('./views/Discounts'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/trace_tokens',
      name: 'trace_tokens',
      component: () => import('./views/TraceTokens'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/trace_token_users/:lid',
      name: 'trace_token_users',
      component: () => import('./views/TraceToken'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/troubleshooting',
      name: 'troubleshooting',
      component: () => import('./views/Troubleshooting'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/customers/:id',
      name: 'customers',
      component: () => import('./views/Customers'),
      beforeEnter: ifAuthenticated,
      children: [
        {
          name: 'customer-teams',
          path: 'teams',
          beforeEnter: ifAuthenticated,
          component: () => import('./components/customers/Teams')
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login'),
      meta: { layout: 'outer' },
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('./views/Signup'),
      meta: { layout: 'outer' },
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/announcements',
      name: 'announcements',
      component: () => import('./views/Announcements'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/operators',
      name: 'operators',
      component: () => import('./views/Operators'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/templates',
      name: 'templates',
      component: () => import('./views/Templates'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/add-content',
      name: 'add_content',
      component: () => import('./views/AddContent'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/add-source',
      name: 'add_source',
      component: () => import('./views/AddSource'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/keywords',
      name: 'keywords',
      component: () => import('./views/Keywords'),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/resources',
      name: 'resources',
      component: () => import('./views/Resources'),
      beforeEnter: ifAuthenticated
    }
  ]
})
